import { FC } from "react";
import { BaseOnboardingContainer } from "../components/BaseOnboardingContainer";
import { RegistrationFlow } from "../flows/RegistrationFlow";

export const RegistrationContainer: FC = () => (
    <BaseOnboardingContainer logoutButtonSize="lg">
        <RegistrationFlow />
    </BaseOnboardingContainer>
);
